/**
 * Archived state of the project currently open, kept at module level so the
 * plain `isPermissionNotGranttedUtil(type, role)` helper can enforce read-only
 * mode without every call site passing it. ProjectProvider owns the value and
 * sets it before exposing tokenContents, and resets it when it unmounts.
 */
let currentProjectArchived = false;

export const setCurrentProjectArchived = (archived: boolean) => {
  currentProjectArchived = archived;
};

export const isCurrentProjectArchived = () => currentProjectArchived;
